import React from 'react';
import { Phone, MapPin, Clock, Check, Sparkles, MessageCircle, Plus } from 'lucide-react';

const coreIncludes = [
  'Live 45 – 60 min numerology meeting',
  'Direct guidance from Mrs. Pujah Chopraa',
  'Verbal answers to your immediate concerns',
];

const addOns = [
  { title: 'Personal Numerology Chart & Decoding', desc: 'Full written chart analysis', price: 'On Request' },
  { title: 'Custom Remedies Pack', desc: 'Three bespoke remedies tailored to your blueprint', price: 'On Request' },
  { title: 'Name Correction & Vibration Audit', desc: 'Detailed name alignment with your life path', price: 'On Request' },
  { title: '48‑Hour Follow‑Up Clarification', desc: 'Written responses to post‑session questions', price: 'On Request' },
];

const PHONE = '+91 98107 33890';
const PHONE_TEL = '+919810733890';
const WA_NUMBER = '919810733890';
const WA_TEXT = encodeURIComponent(
  "Hello Mrs. Pujah Chopraa, I would like to book a numerology reading. Could you please share availability and the add\u2011on options?"
);

const BookReading = () => {
  return (
    <section
      id="reading"
      className="relative py-28 overflow-hidden text-[#faf7f0]"
      style={{
        background:
          'radial-gradient(900px 500px at 20% 20%, rgba(212,175,55,0.15), transparent 65%), radial-gradient(700px 400px at 85% 85%, rgba(168,132,44,0.10), transparent 65%), linear-gradient(180deg, #1a1714 0%, #221c17 100%)',
      }}
    >
      <div className="absolute inset-0 bg-noise opacity-15" />
      <svg className="absolute -right-32 -top-24 opacity-[0.08]" width="520" height="520" viewBox="0 0 200 200" fill="none">
        <circle cx="100" cy="100" r="90" stroke="#d4af37" strokeWidth="0.5" />
        <circle cx="100" cy="100" r="68" stroke="#d4af37" strokeWidth="0.5" />
        <circle cx="100" cy="100" r="46" stroke="#d4af37" strokeWidth="0.5" />
      </svg>

      <div className="relative max-w-6xl mx-auto px-6 lg:px-10">
        <div className="text-center mb-14">
          <div className="ornament justify-center inline-flex mb-4 text-[#c9a961]">
            <Sparkles size={14} />
            <span className="section-eyebrow">Begin Your Reading</span>
          </div>
          <h2 className="font-display text-4xl md:text-5xl lg:text-6xl leading-tight">
            Book a <span className="italic font-cormorant gold-text">private reading</span>
            <br />
            with Mrs. Pujah Chopraa
          </h2>
          <p className="mt-5 max-w-2xl mx-auto text-[15px] text-[#d6cdb8] font-light">
            A quiet, intentional conversation about your name, numbers and cycles.
            Core session begins at ₹1,000. Deeper services are available as add‑ons,
            tailored to each seeker.
          </p>
        </div>

        <div className="grid lg:grid-cols-5 gap-8">
          {/* Core Session Card */}
          <div className="relative lg:col-span-3">
            <div className="absolute -inset-3 border border-[#c9a961]/40 pointer-events-none" />
            <div className="absolute -inset-6 border border-[#c9a961]/15 pointer-events-none hidden sm:block" />

            <div
              className="relative p-6 sm:p-10 md:p-12"
              style={{
                background:
                  'linear-gradient(160deg, #2b2521 0%, #1a1714 60%, #2b2521 100%)',
                border: '1px solid rgba(201,169,97,0.45)',
              }}
            >
              <div className="absolute -top-4 left-6 sm:left-10 px-4 py-1.5 bg-gradient-to-r from-[#a8842c] via-[#d4af37] to-[#a8842c] text-[#1a1714] text-[10px] tracking-[0.35em] uppercase font-semibold">
                Core Session
              </div>

              <div className="mt-2">
                <div className="font-display text-2xl text-[#e8d9a8]">The Signature Meeting</div>
                <div className="shimmer-divider w-16 my-4" />

                <div className="flex items-end gap-2">
                  <span className="font-display text-xs sm:text-sm tracking-[0.25em] uppercase text-[#a99c84] mb-3">Starting from</span>
                </div>
                <div className="flex items-end gap-2">
                  <span className="font-display text-base sm:text-lg text-[#c9a961] mb-2 sm:mb-3">INR</span>
                  <span className="font-display text-5xl sm:text-7xl md:text-8xl gold-text leading-none">1,000</span>
                  <span className="font-display text-sm sm:text-base text-[#a99c84] mb-2 sm:mb-3">/ session</span>
                </div>
                <div className="text-[11px] tracking-[0.3em] uppercase text-[#a99c84] mt-3">
                  45 – 60 minutes · one‑on‑one
                </div>

                <ul className="mt-7 space-y-3">
                  {coreIncludes.map((it) => (
                    <li key={it} className="flex items-start gap-3 text-[14px] text-[#d6cdb8]">
                      <div className="shrink-0 w-5 h-5 rounded-full bg-[#c9a961]/15 border border-[#c9a961]/50 flex items-center justify-center mt-0.5">
                        <Check size={11} className="text-[#e8d9a8]" />
                      </div>
                      <span>{it}</span>
                    </li>
                  ))}
                </ul>

                <div className="mt-8 flex flex-col sm:flex-row gap-3">
                  <a href={`tel:${PHONE_TEL}`} className="btn-gold flex-1 justify-center">
                    <Phone size={14} /> Call {PHONE}
                  </a>
                  <a
                    href={`https://wa.me/${WA_NUMBER}?text=${WA_TEXT}`}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="btn-outline-gold flex-1 justify-center"
                    style={{ color: '#e8d9a8', borderColor: '#c9a961' }}
                  >
                    <MessageCircle size={14} /> WhatsApp
                  </a>
                </div>

                <div className="mt-8 pt-6 border-t border-[#c9a961]/20 grid sm:grid-cols-3 gap-5">
                  <div className="flex items-center gap-3">
                    <div className="w-9 h-9 border border-[#c9a961]/40 flex items-center justify-center rotate-45 shrink-0">
                      <MapPin size={14} className="-rotate-45 text-[#c9a961]" />
                    </div>
                    <div>
                      <div className="text-[10px] tracking-[0.3em] uppercase text-[#a99c84]">Location</div>
                      <div className="font-display text-[14px] text-[#faf7f0]">Delhi / NCR</div>
                    </div>
                  </div>
                  <div className="flex items-center gap-3">
                    <div className="w-9 h-9 border border-[#c9a961]/40 flex items-center justify-center rotate-45 shrink-0">
                      <Phone size={14} className="-rotate-45 text-[#c9a961]" />
                    </div>
                    <div>
                      <div className="text-[10px] tracking-[0.3em] uppercase text-[#a99c84]">Mobile</div>
                      <div className="font-display text-[14px] text-[#faf7f0]">{PHONE}</div>
                    </div>
                  </div>
                  <div className="flex items-center gap-3">
                    <div className="w-9 h-9 border border-[#c9a961]/40 flex items-center justify-center rotate-45 shrink-0">
                      <Clock size={14} className="-rotate-45 text-[#c9a961]" />
                    </div>
                    <div>
                      <div className="text-[10px] tracking-[0.3em] uppercase text-[#a99c84]">Hours</div>
                      <div className="font-display text-[14px] text-[#faf7f0]">10am – 7pm IST</div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Add-Ons Card */}
          <div className="lg:col-span-2">
            <div className="relative h-full">
              <div className="absolute -inset-3 border border-[#c9a961]/25 pointer-events-none" />
              <div
                className="relative h-full p-6 sm:p-8"
                style={{
                  background:
                    'linear-gradient(170deg, #221c17 0%, #1a1714 100%)',
                  border: '1px solid rgba(201,169,97,0.30)',
                }}
              >
                <div className="text-[10px] tracking-[0.35em] uppercase text-[#c9a961] mb-2">Add‑On Services</div>
                <div className="font-display text-2xl text-[#faf7f0]">Deeper Numerology</div>
                <div className="shimmer-divider w-16 my-4" />
                <p className="text-[12.5px] text-[#a99c84] leading-relaxed mb-5">
                  Each remedy, chart or correction is crafted individually. Pricing is shared
                  during your call so it stays honest to your actual needs.
                </p>

                <ul className="space-y-4">
                  {addOns.map((a) => (
                    <li key={a.title} className="flex items-start gap-3 pb-4 border-b border-[#c9a961]/15 last:border-b-0 last:pb-0">
                      <div className="shrink-0 w-6 h-6 border border-[#c9a961]/40 flex items-center justify-center rotate-45 mt-0.5">
                        <Plus size={11} className="-rotate-45 text-[#c9a961]" />
                      </div>
                      <div className="flex-1 min-w-0">
                        <div className="font-display text-[15px] text-[#faf7f0] leading-tight">{a.title}</div>
                        <div className="text-[11.5px] text-[#a99c84] mt-1 leading-snug">{a.desc}</div>
                        <div className="text-[10px] tracking-[0.3em] uppercase text-[#c9a961] mt-1.5">{a.price}</div>
                      </div>
                    </li>
                  ))}
                </ul>

                <a
                  href={`https://wa.me/${WA_NUMBER}?text=${WA_TEXT}`}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="mt-6 inline-flex items-center gap-2 text-[11px] tracking-[0.3em] uppercase text-[#e8d9a8] hover:text-[#faf7f0] transition-colors"
                >
                  Discuss on WhatsApp →
                </a>
              </div>
            </div>
          </div>
        </div>

        <p className="text-center text-[11px] tracking-[0.3em] uppercase text-[#a99c84] mt-12">
          Online (Zoom) & in‑person sessions available · By appointment only
        </p>
      </div>
    </section>
  );
};

export default BookReading;
